<sc-action-icon iconClass="fa-camera-rotate" (click)="showDeviceSelector()"></sc-action-icon>
